import { render } from "./Main.vue?vue&type=template&id=a481d25e"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=a481d25e&lang=css"
script.render = render

export default script